export default __webpack_public_path__ + "static/media/spikes_5.2f5bf378.svg";